import { FetchPolicy, gql } from '@apollo/client'
import { apolloService, loggerService } from '@coachmate/common'
import { TEAM_CORE_FIELDS_FRAGMENT } from '@coachmate/team/graphql/team-fragment.graphql'
import { GqlCoreTeamFieldsFragment, GqlPublicTeamByCodeQuery, GqlPublicTeamByCodeQueryVariables, GqlTeamByCodeInput } from '@graphql'

export const PUBLIC_TEAM_BY_CODE = gql`
  ${TEAM_CORE_FIELDS_FRAGMENT}
  query PublicTeamByCode($input: TeamByCodeInput!) {
    publicTeamByCode(input: $input) {
      ...CoreTeamFields
    }
  }
`

export const publicTeamByCode = async (input: GqlTeamByCodeInput, fetchPolicy: FetchPolicy = 'network-only') => {
  loggerService.debug('[publicTeamByCode] Get team by code.')

  const { data } = await apolloService.query<GqlPublicTeamByCodeQuery, GqlPublicTeamByCodeQueryVariables>({
    query: PUBLIC_TEAM_BY_CODE,
    variables: { input },
    fetchPolicy,
  })

  return data.publicTeamByCode as GqlCoreTeamFieldsFragment | null
}
